import React from "react";

import SideBanner from "components/layout/SideBanner";
import { useFirstAccess } from "features/first-access/hooks/useFirstAccess";

import { Container, Content } from "./FirstAccessPage.styles";

const FirstAccessPage = (): JSX.Element => {
  const { header, step, steppers, stepView } = useFirstAccess();

  return (
    <Container>
      <SideBanner activated={step} header={header} steppers={steppers} />
      <Content>{stepView}</Content>
    </Container>
  );
};

export default FirstAccessPage;
